import React, { useState, useEffect } from 'react';
import { Building2, Save, Loader2 } from 'lucide-react';
import { useProfileStore } from '../../../stores/profileStore';
import { toast } from 'react-hot-toast';

const businessTypes = [
  'Small Business',
  'Corporation',
  'LLC',
  'Nonprofit',
  'Partnership',
  'Sole Proprietorship',
];

export function BusinessDetails() {
  const { profile, loading, updateCompanyInfo } = useProfileStore();
  const [form, setForm] = useState({
    name: '',
    duns_number: '',
    cage_code: '',
    business_type: '',
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (profile?.company) {
      setForm({
        name: profile.company.name || '',
        duns_number: profile.company.duns_number || '',
        cage_code: profile.company.cage_code || '',
        business_type: profile.company.business_type || '',
      });
    }
  }, [profile]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateCompanyInfo(form);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex h-48 items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-purple-600" />
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Company Name
          </label>
          <input
            type="text"
            id="name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500 sm:text-sm"
          />
        </div>

        <div>
          <label htmlFor="duns_number" className="block text-sm font-medium text-gray-700">
            DUNS Number
          </label>
          <input
            type="text"
            id="duns_number"
            value={form.duns_number}
            onChange={(e) => setForm({ ...form, duns_number: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500 sm:text-sm"
          />
        </div>

        <div>
          <label htmlFor="cage_code" className="block text-sm font-medium text-gray-700">
            CAGE Code
          </label>
          <input
            type="text"
            id="cage_code"
            value={form.cage_code}
            onChange={(e) => setForm({ ...form, cage_code: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500 sm:text-sm"
          />
        </div>

        <div>
          <label htmlFor="business_type" className="block text-sm font-medium text-gray-700">
            Business Type
          </label>
          <select
            id="business_type"
            value={form.business_type}
            onChange={(e) => setForm({ ...form, business_type: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500 sm:text-sm"
          >
            <option value="">Select a business type</option>
            {businessTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          disabled={saving}
          className="inline-flex items-center rounded-md border border-transparent bg-purple-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
        >
          {saving ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="mr-2 h-4 w-4" />
              Save Changes
            </>
          )}
        </button>
      </div>
    </form>
  );
}